// extracted by mini-css-extract-plugin
export var emailBlockLink = "_n6-0";